import styles from './option.module.css'

interface Props {
  value: number
  onChange: (value: number) => void
}

export function Option ({ value, onChange }: Props): JSX.Element {
  return (
    <button
      type='button'
      className={styles.option}
      onClick={event => {
        event.stopPropagation()
        onChange(value)
      }}
    >
      {value}
    </button>
  )
}
